var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFileBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 6,
    fill: "white",
    fillOpacity: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4201_39037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5446 7.28018L7.80118 10.7736C7.57207 10.9874 7.44336 11.2774 7.44336 11.5797C7.44336 11.8821 7.57207 12.1721 7.80118 12.3859C8.03029 12.5997 8.34103 12.7198 8.66504 12.7198C8.98905 12.7198 9.29979 12.5997 9.5289 12.3859L13.2723 8.89251C13.7305 8.46489 13.9879 7.88492 13.9879 7.28018C13.9879 6.67544 13.7305 6.09547 13.2723 5.66785C12.8141 5.24023 12.1926 5 11.5446 5C10.8965 5 10.2751 5.24023 9.81685 5.66785L6.07347 9.16123C5.38614 9.80266 5 10.6726 5 11.5797C5 12.4868 5.38614 13.3568 6.07347 13.9982C6.76079 14.6397 7.69301 15 8.66504 15C9.63707 15 10.5693 14.6397 11.2566 13.9982L15 10.5048",
    stroke: "#4A6DE8",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4201_39037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileBlue);
export default __webpack_public_path__ + "static/media/icon-file-blue.3a7e7bdb382db3aaad249c51310a7346.svg";
export { ForwardRef as ReactComponent };